import posthog from 'posthog-js';
import { getEnv } from '@/lib/env';

const isEnvAllowed = () =>
  process.env.NODE_ENV !== 'development' || getEnv('NEXT_PUBLIC_POSTHOG_ENABLE_DEV') === 'true';

if (isEnvAllowed()) {
  if (typeof window !== 'undefined' && getEnv('NEXT_PUBLIC_POSTHOG_KEY')) {
    posthog.init(getEnv('NEXT_PUBLIC_POSTHOG_KEY'), {
      api_host: getEnv('NEXT_PUBLIC_POSTHOG_HOST') || 'https://us.i.posthog.com',
      defaults: '2025-05-24',
      // You can add other config here, e.g.:
      capture_pageview: true,
      capture_pageleave: true,
      session_recording: {
        maskAllInputs: false // Disables masking for all input elements
      },
      loaded: posthog => {
        if (process.env.NODE_ENV === 'development') posthog.debug();
      },
      ui_host: getEnv('NEXT_PUBLIC_APP_URL'),
      enable_heatmaps: true,
      person_profiles: 'always',
      before_send: event => {
        // Only intercept exception events
        if (event.event === '$exception') {
          const exceptionList = event.properties?.['$exception_list'] || [];
          const firstException = exceptionList[0] || {};

          // PostHog uses 'value' to store the main error message string
          const errorMessage = firstException['value'] || '';

          const ignoredErrors = ['Request failed', 'Minified React error'];

          if (ignoredErrors.some(msg => errorMessage.includes(msg))) {
            return false; // Drops the event before it leaves the browser
          }
        }

        return event; // Sends everything else to PostHog
      }
    });
  }
}

export const isPosthogEnabled = () =>
  typeof window !== 'undefined' && isEnvAllowed() && !!getEnv('NEXT_PUBLIC_POSTHOG_KEY');

export default posthog;
